<!-- Top -->
<div
  class="gd-basic-top">

  <!-- Breadcrumbs -->
  <app-breadcrumb-v2
    *ngIf="breadcrumbs"
    [breadcrumbs]="breadcrumbs"
    (detectChanges)="resizeTable()"></app-breadcrumb-v2>

  <!-- Title & buttons -->
  <div
    *ngIf="pageTitle"
    fxLayout="row" fxLayoutGap="0.8rem" fxLayout.lt-md="column"
    class="gd-basic-top-title-buttons">

    <!-- Title -->
    <div
      fxFlex fxFlex.lt-md="none"
      class="gd-basic-top-title-buttons-title">
      {{pageTitle | translate}}
    </div>

    <!-- Buttons -->
    <div
      fxLayoutAlign="end" fxLayoutGap="0.8rem" flexGrow="0"
      class="gd-basic-top-title-buttons-buttons">

      <!-- Action button -->
      <ng-container
        *ngIf="actionButton && (!actionButton.visible || actionButton.visible(null))"
        [ngSwitch]="actionButton.type">

        <!-- Icon / Label -->
        <a
          *ngSwitchCase="V2ActionType.ICON_LABEL"
          mat-flat-button
          [routerLink]="actionButton.action.link && (!actionButton.disable || !actionButton.disable(null)) ? actionButton.action.link(null) : undefined"
          [queryParams]="actionButton.action.linkQueryParams ? actionButton.action.linkQueryParams(null) : undefined"
          [disabled]="actionButton.disable && actionButton.disable(null)"
          (click)="actionButton.action.click ? actionButton.action.click(null) : undefined">

          <!-- Icon -->
          <mat-icon
            *ngIf="actionButton.icon">{{actionButton.icon}}</mat-icon>

          <!-- Label -->
          <span>{{ actionButton.label | translate }}</span>

          <!-- Loading -->
          <mat-progress-spinner
            *ngIf="actionButtonLoading && actionButtonLoading()"
            diameter="16"
            mode="indeterminate"></mat-progress-spinner>
        </a>

        <!-- Icon -->
        <a
          *ngSwitchCase="V2ActionType.ICON"
          class="{{actionButton.cssClasses ? actionButton.cssClasses(null) : ''}}"
          mat-icon-button
          [routerLink]="actionButton.action.link && (!actionButton.disable || !actionButton.disable(null)) ? actionButton.action.link(null) : undefined"
          [queryParams]="actionButton.action.linkQueryParams ? actionButton.action.linkQueryParams(null) : undefined"
          [matTooltip]="actionButton.iconTooltip | translate"
          [disabled]="actionButton.disable && actionButton.disable(null)"
          (click)="actionButton.action.click ? actionButton.action.click(null) : undefined">
          <mat-icon>{{actionButton.icon}}</mat-icon>
        </a>

      </ng-container>

      <!-- Advanced filters -->
      <button
        *ngIf="advancedFilters?.length > 0 && (advancedFiltersVisible === undefined || advancedFiltersVisible)"
        type="button"
        mat-flat-button
        color="primary"
        (click)="showAdvancedFilters()">
        <mat-icon>filter_alt</mat-icon>
        {{'LNG_SIDE_FILTERS_TITLE' | translate}}
      </button>

      <!-- Quick actions -->
      <ng-container
        *ngIf="quickActions && (!quickActions.visible || quickActions.visible(null))">

        <!-- Menu -->
        <!-- IMPORTANT: Menu of type icon isn't supported here -->
        <button
          #quickMenuTrigger="matMenuTrigger"
          class="gd-basic-top-title-buttons-buttons-quick"
          [class.gd-basic-top-title-buttons-buttons-quick-expanded]="quickMenuTrigger.menuOpen"
          type="button"
          mat-flat-button color="secondary"
          [disabled]="quickActions.disable && quickActions.disable(null)"
          [matMenuTriggerFor]="quickMenu"
          (menuClosed)="detectChanges()">

          <!-- Label -->
          <span>
            {{quickActions.label | translate}}
          </span>

          <!-- Icon -->
          <mat-icon>expand_more</mat-icon>
        </button>

        <!-- Floating menu -->
        <mat-menu
          #quickMenu="matMenu"
          class="gd-basic-top-title-buttons-buttons-quick-options">
          <ng-container
            *ngFor="let menuOption of quickActions.menuOptions">
            <ng-container
              *ngIf="!menuOption.visible || menuOption.visible(null)">

              <!-- Child Menu link -->
              <ng-container
                *ngIf="menuOption.label; else divider">

                <!-- Link -->
                <a
                  *ngIf="menuOption.action.link; else notLink"
                  mat-menu-item
                  class="gd-basic-top-title-buttons-buttons-quick-options-option {{menuOption.cssClasses ? menuOption.cssClasses(null) : ''}}"
                  [routerLink]="menuOption.action.link && (!menuOption.disable || !menuOption.disable(null)) ? menuOption.action.link(null) : undefined"
                  [queryParams]="menuOption.action.linkQueryParams ? menuOption.action.linkQueryParams(null) : undefined"
                  [disabled]="menuOption.disable && menuOption.disable(null)">
                  {{menuOption.label.get(null) | translate:(menuOption.label.data ? menuOption.label.data(null) : undefined)}}
                </a>

                <!-- Button -->
                <ng-template
                  #notLink>
                  <button
                    type="button"
                    mat-menu-item
                    class="gd-basic-top-title-buttons-buttons-quick-options-option {{menuOption.cssClasses ? menuOption.cssClasses(null) : ''}}"
                    [disabled]="menuOption.disable && menuOption.disable(null)"
                    (click)="menuOption.action.click ? menuOption.action.click(null) : undefined">
                    {{menuOption.label.get(null) | translate:(menuOption.label.data ? menuOption.label.data(null) : undefined)}}
                  </button>
                </ng-template>

              </ng-container>

              <!-- Divider -->
              <ng-template
                #divider>
                <mat-divider></mat-divider>
              </ng-template>

            </ng-container>
          </ng-container>
        </mat-menu>

      </ng-container>

    </div>
  </div>

</div>

<!-- Content -->
<mat-card
  class="gd-basic-content">
  <ng-content></ng-content>
</mat-card>
